/***
 * @file:è·¯ç±å¤ç¨
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { isEmpty } from 'lodash';

interface IRouteConfigData {
  reuse: boolean;
}
interface ICachedRoute {
  handle: DetachedRouteHandle;
  data: IRouteConfigData;
}

/***
 *
 * shouldDetach æ¯å¦åè®¸å¤ç¨è·¯ç±
 * store å½è·¯ç±ç¦»å¼æ¶ä¼è§¦åï¼å­å¨è·¯ç±
 * shouldAttach æ¯å¦åè®¸è¿åè·¯ç±
 * retrieve è·åå­å¨è·¯ç±
 * shouldReuseRoute è¿å¥è·¯ç±è§¦åï¼æ¯å¦åä¸è·¯ç±æ¶å¤ç¨è·¯ç±
 *
 *
 * æè·¯ç± /list è®¾ç½®ä¸ºåè®¸å¤ç¨ï¼shouldDetachï¼ï¼
 * ç¶åå°è·¯ç±å¿«ç§å­å¨ store å½ä¸­ï¼
 * å½ shouldReuseRoute æç«æ¶å³ï¼
 * åæ¬¡éå° /list è·¯ç±åè¡¨ç¤ºéè¦å¤ç¨è·¯ç±ï¼
 * åå¤æ­ shouldAttach æ¯å¦åè®¸è¿åï¼
 * æåä» retrieve æ¿å°è·¯ç±å¿«ç§å¹¶æå»ºç»ä»¶ã
 *
 *
 * usage:
 *
 * import { RouteReuseService } from './route-reuse/route-reuse';
 *
 * providers: [
        provide: RouteReuseStrategy,
        useClass: RouteReuseService,
      },
      RouteReuseService,
    ],
 * */

@Injectable({
  providedIn: 'root',
})
export class RouteReuseService implements RouteReuseStrategy {
  public static routeCache = new Map<string, ICachedRoute>();
  // å½åé¡µæªè¿è¡å­å¨æ¶éè¦å é¤
  // private static waitDelete: string;
  // å½åé¡µå­å¨è¿æ¶éè¦å é¤
  // private static currentDelete: string;

  /** æ¯å¦åºè¯¥å¤ç¨è·¯ç±ï¼  è¿å¥è·¯ç±è§¦åï¼å¤æ­æ¯å¦æ¯åä¸è·¯ç± */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  /** å¤æ­æ¯å¦è¦å¤ç¨è·¯ç± */
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const routeData = this.getRouteData(route);
    const reuse = routeData && routeData.reuse ? true : false;
    return reuse;
  }

  /** å­å¨è·¯ç±æ°æ®ï¼å½è·¯ç±ç¦»å¼æ¶ä¼è§¦åãæpathä½ä¸ºkeyå­å¨è·¯ç±å¿«ç§&ç»ä»¶å½åå®ä¾å¯¹è±¡ */
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    if (isEmpty(handle)) {
      return;
    }
    const url = this.getFullRouteUrl(route);
    const data = this.getRouteData(route);
    RouteReuseService.routeCache.set(url, { handle, data });
    this.updateWindowRouteCache();

    this.addRedirectsRecursively(route);

    // if (RouteReuseService.waitDelete && RouteReuseService.waitDelete === url) {
    //   // å¦æå¾å é¤æ¯å½åè·¯ç±ï¼ä¸æªå­å¨è¿åä¸å­å¨å¿«ç§
    //   RouteReuseService.waitDelete = null;
    //   return null;
    // } else {
    //   // å¦æå¾å é¤æ¯å½åè·¯ç±ï¼ä¸å­å¨è¿åä¸å­å¨å¿«ç§
    //   if (
    //     RouteReuseService.currentDelete &&
    //     RouteReuseService.currentDelete === url
    //   ) {
    //     RouteReuseService.currentDelete = null;
    //     return null;
    //   } else {
    //     // console.log("åå¾éé¢å­äºï¼",  RouteReuseService.routeCache)
    //     RouteReuseService.routeCache.set(url, { handle, data });
    //     this.addRedirectsRecursively(route);
    //   }
    // }
  }

  /** è¥ path å¨ç¼å­ä¸­æçé½è®¤ä¸ºåè®¸è¿åè·¯ç± */
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const url = this.getFullRouteUrl(route);
    return RouteReuseService.routeCache.has(url);
  }

  /** ä»ç¼å­ä¸­è·åå¿«ç§ï¼è¥æ åè¿ånul */
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    const url = this.getFullRouteUrl(route);
    const data = this.getRouteData(route);
    return data && RouteReuseService.routeCache.has(url) ? RouteReuseService.routeCache.get(url).handle : null;
  }

  private addRedirectsRecursively(route: ActivatedRouteSnapshot): void {
    const config = route.routeConfig;
    if (config) {
      if (!config.loadChildren) {
        const routeFirstChild = route.firstChild;
        const routeFirstChildUrl = routeFirstChild ? this.getRouteUrlPaths(routeFirstChild).join('/') : '';
        const childConfigs = config.children;
        if (childConfigs) {
          const childConfigWithRedirect = childConfigs.find((c) => c.path === '' && !!c.redirectTo);
          if (childConfigWithRedirect) {
            childConfigWithRedirect.redirectTo = routeFirstChildUrl;
          }
        }
      }
      route.children.forEach((childRoute) => this.addRedirectsRecursively(childRoute));
    }
  }

  private getFullRouteUrl(route: ActivatedRouteSnapshot): string {
    return this.getFullRouteUrlPaths(route)
      .filter(Boolean)
      .join('/')
      .replace('/', '_');
  }

  private getFullRouteUrlPaths(route: ActivatedRouteSnapshot): string[] {
    const paths = this.getRouteUrlPaths(route);
    return route.parent ? [...this.getFullRouteUrlPaths(route.parent), ...paths] : paths;
  }

  private getRouteUrlPaths(route: ActivatedRouteSnapshot): string[] {
    const paths = route.url.map((urlSegment) => urlSegment.path);
    // å é¤ /xxx/:idå½¢å¼çè·¯ç±åæ°
    // if (route && !isEmpty(route.params)) {
    //   const params: any = route.params;
    //   const _values: string[] = values(params);
    //   _values.forEach((value) => {
    //     remove(paths, (p) => {
    //       return p === value;
    //     });
    //   });
    // }

    return paths;
  }

  private getRouteData(route: ActivatedRouteSnapshot): IRouteConfigData {
    // console.log("è·¯ç±çä¿¡æ¯", route)
    return route.routeConfig && (route.routeConfig.data as IRouteConfigData);
  }

  // ç¨äºå é¤è·¯ç±å¿«ç§
  public deleteRouteSnapshot(url): void {
    if (url[0] === '/') {
      url = url.substring(1);
    }
    url = url.replace('/', '_');
    if (RouteReuseService.routeCache.has(url)) {
      this.destroy(RouteReuseService.routeCache.get(url).handle, url);
      RouteReuseService.routeCache.delete(url);
      this.updateWindowRouteCache();
      // RouteReuseService.currentDelete = url;
    } else {
      // RouteReuseService.waitDelete = url;
    }
  }

  deleteAllRouteSnapshot() {
    RouteReuseService.routeCache.clear();
    this.updateWindowRouteCache();
    // RouteReuseService.currentDelete = null;
    // RouteReuseService.waitDelete = null;
    // setTimeout(()=>{
    // })
  }

  // è°ç¨ç»ä»¶çå½å¨æ
  destroy(handle, url) {
    url = url.replace('_', '/');
    if (handle) {
      try {
        if (handle.componentRef.componentType.prototype.ngOnDestroy) {
          handle.componentRef.componentType.prototype.ngOnDestroy();
        } else {
          // console.warn(
          //   `please add lifecycle 'ngOnDestroy' in your component of '${url}' to unsubscrible subscription!`
          // );
        }
      } catch (e) {
        // console.log('handle', handle);
        console.warn(`something went wrong in ${url}, please upload this error to your manager!`, e);
      }
    }
  }

  updateWindowRouteCache() {
    (window as any).dtRouteCache = RouteReuseService.routeCache;
  }
}
